import React from 'react'
import PropTypes from 'prop-types'
import DateAndTimeSelector from '../../3_Organisms/DateAndTimeSelector/DateAndTimeSelector'

function DateAndTimeStep({
  handleNextStep,
  title,
  subTitle
}) {
  return (
    <div className="mz-date-and-time-step">
      <div className="mz-date-and-time-step__top">
        <div className="mz-container">
          <div className="mz-full-width">
            <h5 className="mz-date-and-time-step__title">{title}</h5>
            <p>{subTitle}</p>
          </div>
        </div>
      </div>
      <DateAndTimeSelector onSubmit={(data) => handleNextStep({ dateAndTime: data })} />
    </div>
  )
}

DateAndTimeStep.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
}

export default DateAndTimeStep